import React from 'react';
import './EducationLoan.css';
import 'animate.css/animate.min.css';
import Seo from "../components/Seo";






function EducationLoan() {
  return (
    <>

    <Seo
        title="Education Loan - Finance Your Studies with Mortbuzz"
        description="Get the best education loan options in India with Mortbuzz. Compare interest rates and secure funding for your higher education dreams."
        keywords="education loan, student loan, study loan, higher education finance, education loan interest rates, Mortbuzz"
        canonical="https://www.mortbuzz.in/education-loan"
      />

    



{/*        <!-- Hero Section -->  */}
<section className="mortbuzzhheroEducation position-relative d-flex flex-column justify-content-center">
<div className="overlay position-absolute top-0 start-0 w-100 h-100"></div>
    <div className="container">
        <h1 className="animate__animated animate__fadeInDown">Empower Your Future with MortBuzz Education Loan in Pune.</h1>
        <p className="lead animate__animated animate__fadeInUp animate__delay-1s">Apply For Education Loan Online – Smart Funding for Bright Minds.</p>
        <a href="apply-now" className="apply-btn-glass mt-4 animate__animated animate__fadeInUp animate__delay-2s">Apply Now</a>
    </div>
</section>




{/*<!-- About Home Loan -->*/}
<section className="section bg-dark">
    <div className="container">
        <div className="row align-items-center">
            <div className="col-lg-6 mb-4">
                <img src="/images/FrontPage/education-loan-1.png" className="img-fluid rounded shadow animate__animated animate__fadeInLeft" alt="Dream House"/>
            </div>
            <div className="col-lg-6 text-white">
                <h2 className="mb-4 text-white ">Why Choose MortBuzz for Your Education Loan in Pune ?</h2>
                <p>Low interest Education Loan Pune — empower a brighter tomorrow education Loan Without Collateral.

Whether it's for college in Pune & India or abroad, MortBuzz makes education funding simple, affordable, and stress-free. We support your academic dreams with expert guidance and flexible solutions.</p>
                <ul className="list-unstyled mt-3">
                    <li>🎓 Here’s why students and parents trust MortBuzz:</li>
                    <li>✅ Lowest Interest Education loan pune Rates 7.10% p.a* for student-friendly repayments</li>
                    <li>✅ High Loan Amounts – cover tuition, travel, and living costs</li>
                    <li>✅ No Collateral Required (on select loan types)</li>
                    <li>✅ Quick Approvals & Disbursals</li>
                    <li>✅ Flexible Repayment Plans with moratorium periods</li>
                    <li>✅ Full Assistance with documentation and applications</li>
                    <li>✅ Loans for Domestic & International Education</li>
                </ul>
            </div>
        </div>
    </div>
</section>

{/*<!-- Loan Uses -->*/}
<section className="section bg-light">
    <div className="container text-center">
        <h2 className="mb-5">Uses of an Education Loan</h2>
        <div className="row g-4">
            <div className="col-md-4">
                <div className="mortbuzzhcard p-4 animate__animated animate__zoomIn">
                    <h5>Higher Education (India & Abroad)</h5>
                    <p>Fund your college or university education seamlessly, whether you're studying locally or internationally.</p>
                </div>
            </div>
            <div className="col-md-4">
                <div className="mortbuzzhcard p-4 animate__animated animate__zoomIn animate__delay-1s">
                    <h5>Course Fees & Living Expenses</h5>
                    <p>Cover tuition, hostel fees, travel, books, and day-to-day living costs with one comprehensive loan.</p>
                </div>
            </div>
            <div className="col-md-4">
                <div className="mortbuzzhcard p-4 animate__animated animate__zoomIn animate__delay-2s">
                    <h5>Professional & Vocational Courses</h5>
                    <p>Finance skill-based, diploma, or certification programs to boost your career prospects.</p>
                </div>
            </div>
        </div>
    </div>
</section>

<section className="section bg-dark">
    <div className="container">
        <h2 className="text-center mb-5 text-white">Educational Loan in Eligibility Criteria</h2>
        <div className="row text-center">
            {/* CARD 1 */}
            <div className="col-md-3 mb-4">
                <div className="p-3 text-white d-flex flex-column align-items-center">
                    <img 
                        src="/images/Bank Pages/salaried-image-icon.png" 
                        alt="Eligibility" 
                        style={{ width: '200px', height: '200px' }}
                        className="mb-3"
                    />
                    <p className="text-center">Indian citizen pursuing higher education (in Pune India or abroad)</p>
                </div>
            </div>
            {/* CARD 2 */}
            <div className="col-md-3 mb-4">
                <div className="p-3 text-white d-flex flex-column align-items-center">
                    <img 
                        src="/images/Bank Pages/age.png" 
                        alt="Age" 
                        style={{ width: '200px', height: '200px' }} 
                        className="mb-3" 
                    />
                    <p className="text-center">Student Age:17 to 35 years (at the time of loan application)</p>
                </div>
            </div>
            {/* CARD 3 */}
            <div className="col-md-3 mb-4">
                <div className="p-3 text-white d-flex flex-column align-items-center">
                    <img 
                        src="/images/Bank Pages/3-month-experienced.png" 
                        alt="Experience" 
                        style={{ width: '200px', height: '200px' }} 
                        className="mb-3"
                    />
                    <p className="text-center">Academic Qualification:Confirmed admission in a recognized university/institution through entrance test or merit-based selection</p>
                </div>
            </div>
            {/* CARD 4 */}
            <div className="col-md-3 mb-4">
                <div className="p-3 text-white d-flex flex-column align-items-center">
                    <img 
                        src="/images/Bank Pages/minimum-income_20000.png" 
                        alt="Income" 
                        style={{ width: '200px', height: '200px' }} 
                        className="mb-3"
                    />
                    <p className="text-center">Co-applicant Requirement: Parent/guardian must act as a co-applicant (with a stable income source)</p>
                </div>
            </div>
        </div>
    </div>
</section>

{/*<!-- Apply Section -->*/}
<section id="apply" className="section bg-light text-center">
    <div className="container">
        <h2 className="mb-4">Ready to Start Your Journey? To Applying Education Loan In Pune</h2>
        <p>Apply now and let MortBuzz Solutions Advisory guide you to the best Education loan in Pune options.</p>
        <a href="apply-now" className="apply-btn-glass btn-lg mt-3">Apply for Home Loan</a>
    </div>
</section>


{/*<!-- Documentation Required Section -->*/}
<section className="section bg-dark">
    <div className="container">
        <h2 className="text-center mb-5 text-white">Documentation Required – Education Loan</h2>
        <div className="row g-5">

            {/*<!-- Photo Identity Proof -->*/}
            <div className="col-md-6">
                <div className="card shadow-sm p-4 animate__animated animate__fadeInLeft bg-dark border-primary">
                    <div className="d-flex align-items-center mb-3">
                        
                        <img src="/images/Bank Pages/photo-identy.png" alt="Photo-ID" className="me-3" style={{width:'50px'}}/>
                        <h5 className="mb-0 text-white">Student Documents (Applicant)
</h5>
                    </div>
                    <ul className= "text-white">
                        <li>Photo ID Proof
Aadhaar Card / PAN Card / Passport / Driving Licence</li>
                        <li>Address Proof
Aadhaar Card / Passport / Driving Licence / Utility Bill</li>
                        <li>Passport & Visa Copy (for studies abroad)</li>
                        <li>Photographs (passport-size)</li>
                       
                    </ul>
                </div>
            </div>

            {/*<!-- Proof of Residence -->*/}
            <div className="col-md-6">
                <div className="card shadow-sm p-4 animate__animated animate__fadeInRight bg-dark border-primary">
                    <div className="d-flex align-items-center mb-3">
                        <img src="/images/Bank Pages/proof-of-residence.png" alt="Address Proof" className="me-3" style={{width:'50px'}}/>
                        <h5 class="mb-0 text-white">Academic Documents</h5>
                    </div>
                    <ul className="text-white">
                        <li>10th & 12th Mark Sheets</li>
                        <li>Graduation Mark Sheets (if applicable)</li>
                        <li>Admission Letter from College/University</li>
                        <li>Entrance Exam Scorecard (if applicable)</li>
                        
                    </ul>
                </div>
            </div>

          {/* <!-- Income Proof -->*/}
            <div className="col-md-6">
                <div className="card shadow-sm p-4 animate__animated animate__fadeInLeft bg-dark border-primary">
                    <div className="d-flex align-items-center mb-3">
                        <img src="images/Bank Pages/income-proof.png" alt="Income Proof" className="me-3" style={{width:'50px'}}/>
                        <h5 className="mb-0 text-white">Co-applicant (Parent/Guardian) Documents</h5>
                    </div>
                    <ul className="text-white">
                        <li><b>Photo ID Proof</b> :
Aadhaar Card / PAN Card / Passport / Voter ID</li>
                        <li><b>Address Proof </b>
Aadhaar Card / Passport / Driving Licence / Utility Bill</li>
                        <li>Income Proof (choose based on employment type)</li>
                        <li>Income Proof (choose based on employment type)
                       <ul>

                          <li>Last 3 Months' Salary Slips</li>
                          <li>Last 6 Months’ Salary Account Bank Statement</li>
                          <li>Form 16 / ITR (Last 2 Years)</li>
                        </ul></li>
                        <li>Self-Employed:<ul>
                         <li>ITR (Last 3 Years)</li>
                          <li>Business Registration Proof</li>
                          <li>
Audited Financials (Last 3 Years)</li>
                         <li>Bank Statements (Last 6 Months)</li>
                         </ul></li>
                        
                    </ul>
                </div>
            </div>

            {/*<!-- Other Documents -->*/}
            <div className="col-md-6">
                <div className="card shadow-sm p-4 animate__animated animate__fadeInRight bg-dark border-primary">
                    <div className="d-flex align-items-center mb-3">
                        <img src="/images/Bank Pages/other-document.png" alt="Other Documents" className="me-3" style={{width:'50px'}}/>
                        <h5 class="mb-0 text-white">Other Supporting Documents for Education Loan</h5>
                    </div>
                    <ul className="text-white" >
                        <li>Admission Fee Structure from Institution</li>
                        <li>Loan Application Form (duly filled)</li>
                        <li>Affidavit of expenses (if required)</li>
                        <li>Collateral Documents (if applicable)</li>
                        
                    </ul>
                </div>
            </div>

        </div>
    </div>
</section>




{/*<!-- Application Process Section -->*/}
<section className="section bg-dark text-white py-5">
    <div className="container">
      <h2 className="text-center mb-5 text-white">Application Process for Apply for education loan online</h2>
  
      <div className="timeline">
        {/*<!-- Step 1 -->*/}
        <div className="timeline-container left">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 1: Connect with Us</h4>
            <p>Explain your needs. We curate loan products most suitable for your profile.</p>
          </div>
        </div>
  
        {/*<!-- Step 2 -->*/}
        <div className="timeline-container right">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 2: Compare Loan Products</h4>
            <p>We help you compare several Education loan products so you can choose the best one.</p>
          </div>
        </div>
  
        {/*<!-- Step 3 -->*/}
        <div className="timeline-container left">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 3: Apply Online</h4>
            <p>apply for education loan online, and submit all information with our assistance.</p>
          </div>
        </div>
  
        {/*<!-- Step 4 -->*/}
        <div className="timeline-container right">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 4: Application Processing</h4>
            <p>The lender verifies your documentation and processes the application.</p>
          </div>
        </div>
  
      {/*  <!-- Step 5 -->*/}
        <div className="timeline-container left">
          <div className="content bg-dark border border-primary">
            <h4 className="text-primary">Step 5: Receive Funds</h4>
            <p>Upon approval, the loan amount is credited directly to your account.</p>
          </div>
        </div>
  
      </div>
    </div>
  </section>








{/*   <!-- Home Loan Rates Section --> */}
<section className="section bg-light py-5">
    <div className="container">
      <h2 className="text-center mb-5">Home Loan Lowest Interest Rates</h2>
  
      <div className="table-responsive">
        <table className="table table-hover table-striped shadow-lg rounded">
          <thead className="table-primary">
            <tr>
              <th>Bank Name</th>
              <th>Min. Rate of Interest (%)</th>
              <th>Loan Amount</th>
              <th>Loan Tenure</th>
              <th>Processing Fees</th>
              <th>Apply Now</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><a href="https://bankofmaharashtra.in/educational-loans">Bank Of Maharashtra</a></td>
              <td>7.10%</td>
              <td>up to ₹10 lakhs for studies in India and up to ₹20 lakhs for studies abroad.</td>
              <td>10 years - 15 years</td>
              <td>No Processing Fees</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://www.bankofbaroda.in/personal-banking/loans/education-loan">Bank Of Baroda</a></td>
              <td>7.60%</td>
              <td>Upto 80 LAKH</td>
              <td>10 years - 15 years</td>
              <td>1.00%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://bankofindia.co.in/education-loan">Bank Of India </a></td>
              <td>8.40%</td>
              <td>Upto 150 LAKH For Medical</td>
              <td>10 years - 15 years</td>
              <td>0.30%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://www.iob.in/Educational-Loan-IOB-Vidya-Shrest">Indian Overseas Bank</a></td>
              <td>8.25%</td>
              <td>up to Rs. 30 lakhs for foreign studies</td>
              <td>5 years - 25 years</td>
              <td>1.00%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
            <tr>
              <td><a href="https://www.centralbankofindia.co.in/en/cent-education-loans">Central Bank Of India</a></td>
              <td>7.80%</td>
              <td>up to Rs. 20 lakhs</td>
              <td>10 years - 15 years</td>
              <td>1.00%</td>
              <td><a href="apply-now" className="btn btn-primary btn-sm">Apply Now</a></td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </section>





   <section className="section py-5 bg-dark">
    <div className="container">
      <div className="row align-items-center g-5">
     {/*   <!-- Image Section -->*/}
        <div className="col-md-6 text-center">
          <img src="/images/FrontPage/loan-dealing.jpg" alt="Processing Fee" className="img-fluid rounded shadow"/>
        </div>
  
        {/*<!-- Content Section -->*/}
        <div className="col-md-6">
          <h2 className="mb-4 text-primary" style={{fontWeight:' 700'}}>Processing Fee – Education Loan</h2>
          <p style={{fontSize: '17px', color: '#FFEDFA'}}>
            In addition to the interest rate, most education loans come with a <strong> processing fee</strong>, which covers the cost of verifying your documents and handling your loan application.
          </p>
          <p style={{fontSize: '17px', color: '#FBFBFB'}}>
            Typically, the processing fee ranges between<strong> 0.5% to 2% </strong>of the total loan amount. An <strong> 18% GST </strong>is also applicable on this fee as per government regulations.
          </p>
          <p style={{fontSize: '17px' ,color: '#FBFBFB'}}>
            At <strong>MortBuzz Solutions Advisory</strong>, we help you connect with lenders offering minimal or waived processing fees on education loans — so you can focus on your studies, not hidden charges.
          </p>
          
          <a href="apply-now" className="apply-btn-glass mt-3">Get Best Offers</a>
        </div>
      </div>
    </div>
  </section>


<section className="section bg-dark">
    <div className="container">
        <div className="row align-items-center">
            
            <div className="col-lg-6">
                <h2 className="mb-4 text-primary">MortBuzz Solutions – Education Loan Balance Transfer</h2>
                <p className="text-white">Struggling with high interest rates on your existing education loan? It’s time to reduce your financial stress with an Education Loan Balance Transfer. This process allows you to shift your outstanding loan amount from your current lender to a new one offering better interest rates and repayment terms.

Not only can you save money on EMIs, but you may also get additional funds if needed through a top-up loan during the transfer process.</p>
                <ul className="list-unstyled mt-3 text-white">
                    <li>Struggling with high interest rates on your existing education loan? It’s time to reduce your financial stress with an Education Loan Balance Transfer. This process allows you to shift your outstanding loan amount from your current lender to a new one offering better interest rates and repayment terms.

Not only can you save money on EMIs, but you may also get additional funds if needed through a top-up loan during the transfer process.</li>
                    <li><b>🎓 Benefits of Education Loan Balance Transfer with MortBuzz:</b></li>
                    <li>✅ Lowest Interest Rates Starting at 7.60%</li>
                    <li>✅ Top-Up Facility* for extra financial needs</li>
                    <li>✅ 360-Degree Assistance from start to finish</li>
                    <li>✅ Fast & Smooth Processing</li>
                    <li>✅ 100% Cashback on Processing Charges</li>
                    <li>✅ Doorstep Document Pickup</li> 
                </ul>
            </div>

            <div className="col-lg-6 mb-4">
                <img src="/images/Bank Pages/education-loan.png" className="img-fluid rounded shadow animate__animated animate__fadeInLeft" alt="Dream Educated"/>
            </div>
        </div>
    </div>
</section>

{/*<!-- mortbuzz Additionally adding Text Box Section End -->*/}




{/*<!-- FAQ Section -->*/}
<div className="w-100 px-3 px-md-5 py-5 bg-black text-white w-100 bg-black">
  <h2 className="text-center mb-5 display-4 fw-bold text-primary">Frequently Asked Questions</h2>

  <div className="row justify-content-center">
    <div className="col-lg-10 col-md-12">
      <div className="accordion" id="faqAccordion">

       {/* <!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq1">
              <i className="bi bi-question-circle me-3 text-primary fs-4"></i>
              What is MortBuzz Home Loans and how can I apply for a loan?
            </button>
          </h2>
          <div id="faq1" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              MortBuzz offers convenient home loans from top banks. Apply online at 
              <a href="/" className="text-primary text-decoration-none">mortbuzz.in</a>. 
              We handle everything—no bank visit needed.
            </div>
          </div>
        </div>

        {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq2">
              <i class="bi bi-percent me-3 text-primary fs-4"></i>
              What is the interest rate on the home loan?
            </button>
          </h2>
          <div id="faq2" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
              The current interest rate is <strong className="text-success">8.10%</strong>. One of the most competitive in the market. 
              <a href="/" className="text-primary text-decoration-none">Check your eligibility</a> now.
            </div>
          </div>
        </div>

       {/* <!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq3">
              <i class="bi bi-cash-coin me-3 text-primary fs-4"></i>
              How does the cashback offer work?
            </button>
          </h2>
          <div id="faq3" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              Cashback depends on your loan amount:
              <ul className="mt-2">
                <li><strong>Above ₹1 Cr:</strong> 100% cashback on fees.</li>
                <li><strong>₹90 Lakh:</strong> 90% cashback.</li>
                <li><strong>₹20 Lakh:</strong> 20% cashback.</li>
              </ul>
            </div>
          </div>
        </div>

        {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq4">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              What expenses are covered under an education loan?
            </button>
          </h2>
          <div id="faq4" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
              <ol>
                <li>Tuition fees</li>
                <li>Hostel/lodging expenses</li>
                <li>Books and supplies.</li>
                <li>Exam, library, and lab fees</li>
                <li>Travel expenses (for abroad studies).</li>
              </ol>
            </div>
          </div>
        </div>




        {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq5">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
               How much loan can I get?
            </button>
          </h2>
          <div id="faq5" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
              <ol>
                <li>Up to ₹10–15 lakhs for studies in India</li>
                <li>Up to ₹20–40 lakhs (or more) for overseas studies.</li>
                <li>The amount depends on the course, institution, and collateral (if required).

</li>
                
              </ol>
            </div>
          </div>
        </div>



     {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq6">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              Is collateral security required?
            </button>
          </h2>
          <div id="faq6" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              <ol>
                <li>Loans up to ₹7.5 lakhs are often collateral-free</li>
                <li>For higher loan amounts, collateral like property, FD, or insurance may be needed</li>
                <li>Co-applicant income is also considered</li>
                
              </ol>
            </div>
          </div>
        </div>  



    {/*  <!-- Accordion Item --> */}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq7">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              What is the repayment tenure for education loans?
            </button>
          </h2>
          <div id="faq7" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              <ol>
                <li>Usually between 5 to 15 years</li>
                <li>Includes a moratorium period (course duration + 6–12 months) before EMIs start.</li>
               
              </ol>
            </div>
          </div>
        </div>

    {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq8">
              <i class="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              When does repayment start?
            </button>
          </h2>
          <div id="faq8" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
              Repayment typically starts after the moratorium period, giving students time to find employment after graduation.
            </div>
          </div>
        </div>


    {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq9">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
               What are the interest rates for education loans?
            </button>
          </h2>
          <div id="faq9" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
               Rates usually range from 8% to 12% per annum, and can vary based on:
              <ol>
                <li>Loan amount</li>
                <li>Course & institution</li>
                <li>With or without collateral</li>
                
              </ol>
            </div>
          </div>
        </div>


    {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq10">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
               Are there any tax benefits on education loans?
            </button>
          </h2>
          <div id="faq10" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div className="accordion-body text-light border-start border-primary ps-4">
              Yes, under Section 80E of the Income Tax Act, the interest paid on education loans is fully deductible for up to 8 years.
            </div>
          </div>
        </div>

    {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq11">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              How can I apply for an education loan?
            </button>
          </h2>
          <div id="faq11" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
                You can:
              <ol>
                <li>Visit a bank/NBFC branch</li>
                <li>Apply online via platforms like MortBuzz</li>
                <li>Submit documents like admission proof, fee structure, co-applicant details, etc.</li>
                
              </ol>
            </div>
          </div>
        </div>


    {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq12">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              Can I prepay my education loan early?
            </button>
          </h2>
          <div id="faq12" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
              Yes, most lenders allow prepayment or foreclosure without penalty after a certain period, helping you save on interest.
            </div>
          </div>
        </div>

    {/*<!-- Accordion Item -->*/}
        <div className="accordion-item bg-dark border-0 shadow mb-4 rounded-3">
          <h2 className="accordion-header">
            <button className="accordion-button collapsed bg-dark text-white fw-semibold fs-5" 
                    type="button" data-bs-toggle="collapse" data-bs-target="#faq13">
              <i className="bi bi-diagram-3 me-3 text-primary fs-4"></i>
              What is the process for obtaining a home loan from MortBuzz?
            </button>
          </h2>
          <div id="faq13" className="accordion-collapse collapse" data-bs-parent="#faqAccordion">
            <div class="accordion-body text-light border-start border-primary ps-4">
              <ol>
                <li>Apply at <a href="https://mortbuzz.in" class="text-primary">mortbuzz.in</a>.</li>
                <li>Our team will collect your documents.</li>
                <li>We handle approval with banks.</li>
                <li>Door-to-door service with no bank visits.</li>
                <li>Enjoy cashback and fast approval.</li>
              </ol>
            </div>
          </div>
        </div>
      </div>
          </div>
  </div>
</div>














    </>
  );
}

export default EducationLoan;